import { CircularProgress, IconButton, Tooltip, useTheme } from '@mui/material';
import { useState } from 'react';

type PropsType = {
  title: string;
  icon: React.ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
};

const BaseIconComponent = ({
  title,
  icon,
  onClick,
  isLoading,
  isDisabled,
}: PropsType) => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Tooltip title={title} placement="top" arrow disableInteractive>
      <IconButton
        onMouseOver={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
        size="small"
        disabled={isDisabled}
        color={isHovered ? 'primary' : 'inherit'}
        sx={{
          width: theme.spacing(5),
          height: theme.spacing(5),
          '&:hover': {
            backgroundColor: theme.palette.grey[600],
            '& svg': {
              color: theme.palette.primary.main,
            },
          },
        }}
        data-testid={title}
      >
        {isLoading ? (
          <CircularProgress
            sx={{ color: theme.palette.grey[50] }}
            size={theme.spacing(2.5)}
          />
        ) : (
          <>{icon}</>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default BaseIconComponent;
